import { TokenWithBalance } from '@/domain/common/types'
import { TokenSymbol } from '@/domain/types/TokenSymbol'
import { Panel } from '@/ui/atoms/panel/Panel'
import { Typography } from '@/ui/atoms/typography/Typography'
import { ControlledMultiSelectorAssetInput } from '@/ui/organisms/multi-selector/ControlledMultiSelectorAssetInput'
import { Control } from 'react-hook-form'
import { BridgeToken, TradeFormSchema } from '../../logic/useTrade'
import { SearchableAssetSelector } from '../dropdown/SearchableAssetSelector'

interface ToProps {
  control: Control<TradeFormSchema>
  assets: (TokenWithBalance | BridgeToken)[]
  selectedAsset: TokenWithBalance | BridgeToken
  changeToken: (newSymbol: TokenSymbol, isL1: boolean) => void
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  maxSelectedFieldName?: string
  lockToToken?: boolean
}

export function To(props: ToProps) {
  const { control, assets, selectedAsset, changeToken, onChange, lockToToken } = props

  return (
    <Panel.Wrapper className="mt-2 p-4 pb-5">
      <div className="flex flex-row items-center gap-1">
        <Typography variant="h4" className="py-3 font-semibold">
          To
        </Typography>
      </div>
      <div>
        <div className="mt-2 flex flex-row items-start gap-2">
          <ControlledMultiSelectorAssetInput
            fieldName="to.value"
            control={control}
            disabled
            token={selectedAsset.token}
            customOnChange={onChange}
            readOnly
          />

          <SearchableAssetSelector
            assets={assets}
            selectedAsset={selectedAsset}
            setSelectedAsset={changeToken}
            isDestination
            disabled={lockToToken}
          />
        </div>
      </div>
    </Panel.Wrapper>
  )
}
